import { defineMessages } from 'react-intl'

export default defineMessages({
    particular: {
        defaultMessage: 'Garaje particular',
    },
    airport: {
        defaultMessage: 'Aeropuerto',
    },
    trucks: {
        defaultMessage: 'Camiones',
    },
    airportOfficial: {
        defaultMessage: 'AENA Oficial',
    },
    mowizTruck: {
        defaultMessage: 'Red mowiz TRUCK',
    },
})
